import { render } from "./ProductSegmentValue.vue?vue&type=template&id=3157e380"
import script from "./ProductSegmentValue.vue?vue&type=script&lang=js"
export * from "./ProductSegmentValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__